<template>
  <div
    v-if="payload.widgetType === WIDGET_TYPE.ARTICLES && articles.length"
    id="articles-widget"
    class="preview-widget preview-widget--full"
  >
    <div class="articles">
      <h3 v-show="payload.title">
        {{ payload.title }}
      </h3>
      <div class="articles__items">
        <a
          v-for="article in articles"
          :key="article.id"
          class="articles__item"
          :href="`/${article.categories[0].slug || 'materials'}/${article.slug || article.id}`"
        >
          <img
            :src="article.coverUrl"
            :alt="article.title"
            loading="lazy"
          >
          <h4 :title="article.title">
            {{ article.title }}
          </h4>
          <p>{{ article.previewText }}</p>
        </a>
      </div>
    </div>
  </div>

  <div
    v-else-if="payload.widgetType === WIDGET_TYPE.BANNER"
    id="banner-widget"
    class="preview-widget"
  >
    <div class="banner">
      <h3 v-show="payload.title">
        {{ payload.title }}
      </h3>
      <p>{{ payload.values.text }}</p>
      <a
        :href="payload.values.link"
        target="_blank"
        v-text="payload.values.button || 'Подробнее'"
      />
      <img
        src="../../../assets/images/banner-image.png"
        alt="banner"
      >
    </div>
  </div>

  <div
    v-else-if="payload.widgetType === WIDGET_TYPE.BUTTONS"
    id="buttons-widget"
    class="preview-widget"
  >
    <div class="buttons">
      <h3 v-show="payload.title">
        {{ payload.title }}
      </h3>
      <div class="buttons__items">
        <a
          v-for="(button, idx) in payload.values"
          :key="idx"
          :href="button.link"
          target="_blank"
          v-text="button.text"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { WIDGET_TYPE } from '../constants';

export default {
  name: 'PreviewWidgets',
  props: {
    payload: { type: Object, required: true },
    getMaterialsFunc: { type: Function, required: true },
  },
  data: () => ({
    articles: [],
    WIDGET_TYPE,
  }),
  async created() {
    if (this.payload.widgetType === WIDGET_TYPE.ARTICLES && this.payload.values.length) {
      const filter = { ids: this.payload.values };
      this.articles = await this.getMaterialsFunc.call(this.$api || this, filter);
    }
  },
};
</script>

<style scoped lang="scss">
@import "../../../styles/main.scss";

.articles,
.buttons {
  h3 {
    color: $grey;
    font-weight: 700;
    font-size: 2rem;
    line-height: 134%;
    text-align: center;
  }
}

.preview-widget:not(.preview-widget--full) {
  max-width: 860px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.articles {
  // max-width: 1135px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  h3 {
    margin-bottom: 2rem;
  }

  &__items {
    display: flex;
    gap: 1.5rem;
    flex-wrap: wrap;
  }

  &__item {
    padding: 1.5rem;
    width: calc(33.3% - 1rem);
    background-color: $white-color;
    box-shadow: 0 1rem 4rem rgba($almostBlack, 0.06);
    border-radius: 2rem;
    color: $grey !important;
    display: inline-block;
    text-decoration: none !important;

    img {
      aspect-ratio: 16/9;
      width: 100%;
      object-fit: cover;
      margin-bottom: 1.5rem;
      border-radius: 1.5rem;
    }

    h4 {
      font-size: 1.5rem;
      line-height: 1.6rem;
      font-weight: 600;
      margin-bottom: 1.5rem;

      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    p {
      font-size: 1rem;
      line-height: 1.5rem;
    }

    @include media-down(tablet) {
      width: 100%;
    }
  }
}

.banner {
  background: linear-gradient(180deg, #A78AEC 0%, $violet-color 100%);
  box-shadow: 0 16px 64px rgba($almostBlack, 0.06);
  border-radius: 32px;
  width: 362px;
  padding: 1.5rem;
  position: relative;
  overflow: hidden;

  * {
    z-index: 2;
    position: relative;
    color: $white-color !important;
  }

  h3 {
    margin-bottom: 1rem;
    font-weight: 600;
    font-size: 1.5rem;
    line-height: 1.6rem;
  }

  p {
    margin-bottom: 1rem;
    font-size: 1rem;
    line-height: 1.5rem;
  }

  a {
    background: $orange-color;
    box-shadow: 0 0.75rem 2rem rgba(255, 153, 0, 0.32);
    border-radius: 1rem;
    height: 60px;
    line-height: 60px;
    text-decoration: none!important;
    text-align: center;
    width: 100%;
    font-size: 1.25rem;
    display: inline-block;
  }

  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
  }
}

.buttons {
  background-color: $white-color;
  border-radius: 2rem;
  max-width: 825px;
  width: 100%;
  padding: 1.5rem;
  position: relative;

  h3 {
    margin-bottom: 1.5rem;
  }

  &__items {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }

  a {
    display: inline-block;
    color: $violet-color !important;
    padding: 0.725rem 1rem;
    height: 45px;
    line-height: 1;
    text-decoration: none !important;
    border: 2px solid $violet-color;
    border-radius: 1rem;
    transition: 0.2s;

    &:hover {
      background-color: $violet-color;
      color: $white-color !important;
    }
  }
}

</style>
